var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade modal-upload",
      attrs: {
        id: "addUser",
        "data-keyboard": "false",
        "data-backdrop": "static"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading == true,
                  expression: "(loading == true)"
                }
              ],
              staticClass: "loading-backdrop"
            },
            [_c("div", { staticClass: "loading" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "data-dismiss": "modal" }
              },
              [_vm._v("×")]
            ),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.addUser.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", { staticClass: "center-modal ex-input-center" }, [
                  _c("div", { staticClass: "center-ttl text-center" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("user.add.title")) +
                        "\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.alert_error
                    ? _c(
                        "div",
                        {
                          staticClass: "error-message",
                          attrs: { "data-vv-scope": "s1" }
                        },
                        [
                          _c("div", { staticClass: "d-flex" }, [
                            _c("i", { staticClass: "icon-warning mr-2" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "errror-txt" }, [
                              _c(
                                "p",
                                { staticClass: "fs-14 text-red font600" },
                                [_vm._v(_vm._s(_vm.$t("error.title")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "fs-14 text-red font600" },
                                [_vm._v(_vm._s(_vm.alert_error))]
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.passwordNew == null && _vm.init == true
                    ? _c("div", { attrs: { "data-vv-scope": "s2" } }, [
                        _c("div", { staticClass: "form-input" }, [
                          _c("label", { staticClass: "form-input-lb" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("user.general.username")) +
                                " "
                            ),
                            _c("span", { staticClass: "text-red" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-input-cnt",
                              class: {
                                "ex-has-error": _vm.errors.has("username")
                              }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.user.username,
                                    expression: "user.username"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate.disable",
                                    value: {
                                      required: true,
                                      min: 1,
                                      max: 100,
                                      regex: /^[a-zA-Z0-9@\-_\.]*$/
                                    },
                                    expression:
                                      "{required:true,min:1,max:100,regex:/^[a-zA-Z0-9@\\-_\\.]*$/}",
                                    modifiers: { disable: true }
                                  }
                                ],
                                key: "username",
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  autocomplete: "off",
                                  name: "username",
                                  placeholder: _vm.$t("place_holder.username"),
                                  "data-vv-as": _vm.$t("user.general.username")
                                },
                                domProps: { value: _vm.user.username },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.user,
                                      "username",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("username"),
                                      expression: "errors.has('username')"
                                    }
                                  ],
                                  staticClass: "error-text"
                                },
                                [_vm._v(_vm._s(_vm.errors.first("username")))]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-input" }, [
                          _c("label", { staticClass: "form-input-lb" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("user.general.full_name")) +
                                " "
                            ),
                            _c("span", { staticClass: "text-red" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-input-cnt",
                              class: {
                                "ex-has-error": _vm.errors.has("fullName")
                              }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.user.fullName,
                                    expression: "user.fullName"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate.disable",
                                    value: "required|min:1|max:255",
                                    expression: "'required|min:1|max:255'",
                                    modifiers: { disable: true }
                                  }
                                ],
                                key: "fullName",
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  autocomplete: "off",
                                  name: "fullName",
                                  placeholder: _vm.$t("place_holder.full_name"),
                                  "data-vv-as": _vm.$t("user.general.full_name")
                                },
                                domProps: { value: _vm.user.fullName },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.user,
                                      "fullName",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("fullName"),
                                      expression: "errors.has('fullName')"
                                    }
                                  ],
                                  staticClass: "error-text"
                                },
                                [_vm._v(_vm._s(_vm.errors.first("fullName")))]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-input" }, [
                          _c("label", { staticClass: "form-input-lb" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("company.general.full_name")) +
                                " "
                            ),
                            _c("span", { staticClass: "text-red" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-input-cnt",
                              class: {
                                "ex-has-error": _vm.errors.has("companyId")
                              }
                            },
                            [
                              _c("select2", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate.disable",
                                    value: "required",
                                    expression: "'required'",
                                    modifiers: { disable: true }
                                  }
                                ],
                                key: "companyId",
                                attrs: {
                                  id: "companyId",
                                  "data-vv-as": _vm.$t(
                                    "company.general.full_name"
                                  ),
                                  name: "companyId",
                                  options: _vm.selectCompanyId,
                                  settings: _vm.selectCompanyIdSettings
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.selectCompanyIdChangeEvent(
                                      $event
                                    )
                                  },
                                  select: function($event) {
                                    return _vm.selectCompanyIdEvent($event)
                                  }
                                },
                                model: {
                                  value: _vm.user.companyId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.user, "companyId", $$v)
                                  },
                                  expression: "user.companyId"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("companyId"),
                                      expression: "errors.has('companyId')"
                                    }
                                  ],
                                  staticClass: "error-text"
                                },
                                [_vm._v(_vm._s(_vm.errors.first("companyId")))]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-input" }, [
                          _c("label", { staticClass: "form-input-lb" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("group.general.name")) +
                                " "
                            ),
                            _c("span", { staticClass: "text-red" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-input-cnt",
                              class: {
                                "ex-has-error": _vm.errors.has("groupId")
                              }
                            },
                            [
                              _c("select2", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate.disable",
                                    value: "required",
                                    expression: "'required'",
                                    modifiers: { disable: true }
                                  }
                                ],
                                key: "groupId",
                                attrs: {
                                  id: "groupId",
                                  "data-vv-as": _vm.$t("group.general.name"),
                                  name: "groupId",
                                  options: _vm.selectGroupId,
                                  settings: _vm.selectGroupIdSettings
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.selectGroupIdChangeEvent($event)
                                  },
                                  select: function($event) {
                                    return _vm.selectGroupIdEvent($event)
                                  }
                                },
                                model: {
                                  value: _vm.user.groupId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.user, "groupId", $$v)
                                  },
                                  expression: "user.groupId"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("groupId"),
                                      expression: "errors.has('groupId')"
                                    }
                                  ],
                                  staticClass: "error-text"
                                },
                                [_vm._v(_vm._s(_vm.errors.first("groupId")))]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-input" }, [
                          _c("label", { staticClass: "form-input-lb" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("user.general.role")) +
                                " "
                            ),
                            _c("span", { staticClass: "text-red" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-input-cnt",
                              class: {
                                "ex-has-error": _vm.errors.has("roleId")
                              }
                            },
                            [
                              _c("select2", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate.disable",
                                    value: "required",
                                    expression: "'required'",
                                    modifiers: { disable: true }
                                  }
                                ],
                                key: "roleId",
                                attrs: {
                                  id: "roleId",
                                  name: "roleId",
                                  "data-vv-as": _vm.$t("user.general.role"),
                                  options: _vm.selectRoleId,
                                  settings: _vm.selectRoleIdSettings
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.selectRoleIdChangeEvent($event)
                                  },
                                  select: function($event) {
                                    return _vm.selectRoleIdEvent($event)
                                  }
                                },
                                model: {
                                  value: _vm.user.roleId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.user, "roleId", $$v)
                                  },
                                  expression: "user.roleId"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("roleId"),
                                      expression: "errors.has('roleId')"
                                    }
                                  ],
                                  staticClass: "error-text"
                                },
                                [_vm._v(_vm._s(_vm.errors.first("roleId")))]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-input" }, [
                          _c("label", { staticClass: "form-input-lb" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("user.general.start_date")) +
                                "\n                                "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-input-cnt",
                              class: {
                                "ex-has-error": _vm.errors.has("start_date")
                              }
                            },
                            [
                              _c("date-picker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate.disable",
                                    value: "date_format:yyyy.MM.DD",
                                    expression: "'date_format:yyyy.MM.DD'",
                                    modifiers: { disable: true }
                                  }
                                ],
                                key: "start_date",
                                ref: "start_date",
                                attrs: {
                                  name: "start_date",
                                  placeholder: _vm.$t(
                                    "place_holder.start_date"
                                  ),
                                  "data-vv-as": _vm.$t(
                                    "user.general.start_date"
                                  ),
                                  format: "YYYY.MM.DD",
                                  "disabled-date": _vm.notBeforeDate,
                                  editable: false
                                },
                                on: { change: _vm.changeDate },
                                model: {
                                  value: _vm.user.validPeriodFrom,
                                  callback: function($$v) {
                                    _vm.$set(_vm.user, "validPeriodFrom", $$v)
                                  },
                                  expression: "user.validPeriodFrom"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("start_date"),
                                      expression: "errors.has('start_date')"
                                    }
                                  ],
                                  staticClass: "error-text"
                                },
                                [_vm._v(_vm._s(_vm.errors.first("start_date")))]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-input" }, [
                          _c("label", { staticClass: "form-input-lb" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.$t("user.general.end_date")) +
                                "\n                                "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-input-cnt",
                              class: {
                                "ex-has-error": _vm.errors.has("end_date")
                              }
                            },
                            [
                              _c("date-picker", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate.disable",
                                    value: "date_format:yyyy.MM.DD",
                                    expression: "'date_format:yyyy.MM.DD'",
                                    modifiers: { disable: true }
                                  }
                                ],
                                key: "end_date",
                                ref: "end_date",
                                attrs: {
                                  name: "end_date",
                                  placeholder: _vm.$t("place_holder.end_date"),
                                  "data-vv-as": _vm.$t("user.general.end_date"),
                                  format: "YYYY.MM.DD",
                                  "disabled-date": _vm.notBeforeDate,
                                  editable: false
                                },
                                on: { change: _vm.changeDate },
                                model: {
                                  value: _vm.user.validPeriodTo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.user, "validPeriodTo", $$v)
                                  },
                                  expression: "user.validPeriodTo"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("end_date"),
                                      expression: "errors.has('end_date')"
                                    }
                                  ],
                                  staticClass: "error-text"
                                },
                                [_vm._v(_vm._s(_vm.errors.first("end_date")))]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-center mt-4 pt-4"
                          },
                          [
                            _c("div", { staticClass: "pr-2 w-165" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-pink-53 w-100",
                                  attrs: {
                                    type: "submit",
                                    disabled: _vm.submitted
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.$t("button.ok")) +
                                      "\n                                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pl-2 w-165" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-gray-53 w-100",
                                  attrs: {
                                    "data-dismiss": "modal",
                                    type: "button",
                                    disabled: _vm.submitted
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.$t("button.cancel")) +
                                      "\n                                    "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.passwordNew != null && _vm.init == false
                    ? _c("div", { attrs: { "data-vv-scope": "s3" } }, [
                        _c("p", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("login.password")))
                          ]),
                          _vm._v(" :\n                                "),
                          _c("span", [_vm._v(_vm._s(_vm.passwordNew))])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-center mt-4 pt-4"
                          },
                          [
                            _c("div", { staticClass: "pl-2 w-165" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-pink-53 w-100",
                                  attrs: {
                                    "data-dismiss": "modal",
                                    type: "button"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.$t("button.ok")) +
                                      "\n                                    "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5eb59e6f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eb59e6f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/admin/UserManagement/Add.vue
// module id = null
// module chunks = 